export default class Radar {
    constructor (map) {
        this.urlRequestAPI = 'api/v2/link/';
        this.urlRadar = 'radar';
        this.tokenRadar = 'token';
        this.errors = {
            invalidLink: fmtools.translate('RadarInvalidLink'),
            errorGetTrack: fmtools.translate('RadarErrorGetTrack'),
            errorGetObjects: fmtools.translate('RadarErrorGetObjects')
        }
        this.map = map;
        this.lastDate = null;
        this.token = null;
        this.toFollow = false;
        this.currentMarker = null;
        let isRadar = window.location && window.location.pathname.indexOf(this.urlRadar) != -1;
        if (isRadar) {
            let currentUrl = new URL(document.location);
            this.token = currentUrl.searchParams.get(this.tokenRadar);
            if (this.isExist()) {
                this.urlRequestMarkers = `${currentUrl.protocol}//${currentUrl.host}/${this.urlRequestAPI}`;
            } else {
                this.showErrorLink(this.errors.invalidLink);
            }
        }
    }

    isExist () {
        return !!this.token;
    }

    requestData(url, errorMessage, showErrorFunction = this.showErrorLink) {
        if (this.isExist()) {
            return fetch(url)
                    .then( response => {
                        if (response.status >= 200 && response.status < 300) {
                            this.lastDate = this.getCurrentDate();
                            return response.json();
                        } else {
                            let error = new Error(response.statusText);
                            error.response = response;
                            throw error;
                        }
                    })
                    .catch((error) => {
                        showErrorFunction(errorMessage);
                        console.log(error);
                    });
        } else {
            showErrorFunction(errorMessage);
        }                    
    }

    getMarkersRequest () {
        let url = new URL(`${this.urlRequestMarkers}info`);
        url.searchParams.append(this.tokenRadar,this.token);
        return this.requestData(url, this.errors.invalidLink);
    }

    updateMarkersRequest () {
        let url = new URL(`${this.urlRequestMarkers}updateinfo`);
        url.searchParams.append(this.tokenRadar,this.token);
        url.searchParams.append('lastDate',this.lastDate);
        return this.requestData(url, this.errors.errorGetObjects);
    }

    getTrackRequest (props) {
        let { objectId, startTime, stopTime } = props;
        let url = new URL(`${this.urlRequestMarkers}track`);
        url.searchParams.append(this.tokenRadar, this.token);
        url.searchParams.append('objectId', objectId);
        url.searchParams.append('startTime', startTime);
        url.searchParams.append('stopTime', stopTime);
        url.searchParams.append('disableStops', true);
        return this.requestData(url, this.errors.errorGetTrack, alert);
    }

    showErrorLink (message) {
        document.body.innerHTML = '';
        let errorBlock = document.createElement('div');
        errorBlock.classList.add('error-radar');
        errorBlock.innerHTML = message;
        document.body.appendChild(errorBlock);
    }

    getCurrentDate () {
        let d = new Date(),
            yyyy = d.getUTCFullYear(),
            month = d.getUTCMonth() + 1,
            dd = d.getUTCDate(),
            hh = d.getUTCHours(),
            mm = d.getUTCMinutes(),
            ss = d.getUTCSeconds();
        return `${yyyy}-${month}-${dd} ${hh}:${mm}:${ss}`;
    }

    setToFollow (val) {
        this.toFollow = val;
    }

    isFollowObject () {
        return this.toFollow;
    }

    setCurrentMarker(val) {
        this.currentMarker = val;
    }

    followObject() {
        this.isFollowObject() &&
        this.currentMarker &&
        this.map.setView([this.currentMarker.lat, this.currentMarker.lon]);        
    }
}